<template>
  <div
    :class="['brand-item', layout === 'grid' ? 'brand-item--grid' : 'brand-item--list']"
  >
    <div
      v-if="is_radio && layout !== 'grid'"
      class="brand-item__radio"
      @click="changeCheckStatus"
    >
      <div role="radiogroup" class="van-radio-group" v-if="check_status">
        <div role="radio" tabindex="0" aria-checked="true" class="van-radio">
          <div class="van-radio__icon van-radio__icon--round van-radio__icon--checked">
            <i class="van-icon van-icon-success"></i>
          </div>
        </div>
      </div>
      <div role="radiogroup" class="van-radio-group" v-else>
        <div role="radio" tabindex="-1" aria-checked="false" class="van-radio">
          <div class="van-radio__icon van-radio__icon--round">
            <i class="van-icon van-icon-success"></i>
          </div>
        </div>
      </div>
    </div>

    <a
      v-if="detail && detail.tit_count > 1"
      class="brand-item__multi-tag"
      :class="{ 'brand-item__multi-tag--grid': layout === 'grid' }"
      :style="layout !== 'grid' ? {
        right: is_radio ? '40px' : '12px'
      } : {}"
    >多类别</a>

    <div
      class="brand-item__collect"
      :class="{ 'brand-item__collect--grid': layout === 'grid' }"
      @click.stop="addCollect"
    >
      <van-icon :name="in_collect ? 'like' : 'like-o'" :class="{ 'is-active': in_collect }" />
    </div>

    <div
      v-if="layout === 'grid'"
      class="brand-item__grid-card"
    >
      <div class="brand-item__grid-image" @click="showDetail">
        <img v-if="detail && detail.cover_img" :src="detail.cover_img" :alt="detail.tit" />
      </div>
      <div class="brand-item__grid-caption" v-if="detail" @click="showDetail">
        {{ gridCaption }}
      </div>
      <div class="brand-item__grid-footer" v-if="detail">
        <div
          class="brand-item__grid-price"
          v-if="detail.display_price > 0"
          @click="showDetail"
        >
          <span>¥</span>{{ formatPrice(detail.display_price) }}
        </div>
        <div v-else class="brand-item__grid-price brand-item__grid-price--empty"></div>
        <van-button
          type="danger"
          size="mini"
          round
          class="brand-item__grid-order-btn"
          @click.stop="goOrder"
        >
          下单
        </van-button>
      </div>
    </div>

    <div
      v-else
      class="brand-item__list-card"
      @click="showDetail"
    >
      <div class="brand-item__list-image">
        <img v-if="detail && detail.cover_img" :src="detail.cover_img" :alt="detail.tit" />
      </div>

      <div class="brand-item__list-info">
        <div>
          <div class="brand-item__list-title" v-if="detail">
            {{ detail.classify }}类- {{ detail.tit }}
          </div>

          <div class="brand-item__list-meta" v-if="detail">
            有效期: {{ detail.valid_date || '-' }}
          </div>

          <div
            class="brand-item__list-meta"
            v-if="detail && detail.same_name_ty2id"
          >
            多类: {{ formatSameName(detail.same_name_ty2id) }}
          </div>
        </div>

        <div class="brand-item__list-footer">
          <div class="brand-item__list-price" v-if="detail && detail.display_price > 0">
            <span>¥</span>{{ formatPrice(detail.display_price) }}
          </div>
          <div v-else></div>

          <van-button
            type="danger"
            size="small"
            round
            class="brand-item__order-btn"
            @click.stop="goOrder"
          >
            立即下单
          </van-button>
        </div>
      </div>
    </div>

    <van-popup position="top" class="product_detail" v-model="product_show">
      <div
        style="
          background-color: #ffffff;
          min-height: 80px;
          width: 100%;
          padding: 16px;
          box-sizing: border-box;
          padding-top: 46px;
        "
      >
        <div
          style="
            position: relative;
            font-size: 0;
            border-bottom: 1px solid #f1f1f1;
          "
        >
          <div style="padding-bottom: 55%; background: #ffffff">
            <div class="ab-t-t-x-y">
              <img :src="detail.cover_img" style="width: 100%" />
            </div>
          </div>

          <div
            style="position: absolute; left: 16px; top: 16px"
            @click="goBack"
          >
            <div
              style="
                width: 36px;
                height: 36px;
                background: #7e7e7e;
                border-radius: 100%;
                text-align: center;
                line-height: 36px;
                color: #ffffff;
                font-size: 20px;
              "
            >
              <van-icon name="arrow-left" style="line-height: 36px" />
            </div>
          </div>
        </div>

        <div style="padding: 12px">
          <div class="detail-block">
            <div
              class="detail-title t-al-l"
              style="
                font-size: 18px;
                font-weight: bold;
                color: rgb(255, 120, 12);
              "
            >
              {{ detail.tit }}
            </div>
          </div>

          <div class="detail-block">
            <div
              class="detail-title t-al-l"
              style="font-size: 18px; padding: 12px 0"
            >
              商标信息
            </div>
          </div>

          <div class="detail-block">
            <div
              style="
                font-size: 14px;
                line-height: 30px;
                color: #959595;
                text-align: left;
              "
            >
              有效期限：{{ detail.valid_date }}<br />
              所属类别：{{ detail.classify }}类 - {{ detail.classify_name
              }}<br />

              类似群组：{{ detail.analogues_group }}<br />
              适用项目：{{ detail.fit_projects }}<br />

              <!-- 价格显示 -->
              <div v-if="detail.display_price > 0" style="color: #ee0a24; font-weight: bold; font-size: 16px; margin-top: 8px;">
                价格：<span style="font-size: 12px;">¥</span>{{ formatPrice(detail.display_price) }}
              </div>

              <div style="margin-top: 16px;">
                <van-button type="danger" block round @click="goOrder">下单</van-button>
              </div>

              <!--输出五行信息-->
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<style scoped>
.product_item_checked {
  border: 1px solid #da4725 !important;
}

.brand-item {
  position: relative;
  text-align: center;
  font-size: 14px;
}

.brand-item--list {
  margin-bottom: 12px;
}

.brand-item--grid {
  margin-bottom: 0;
}

.brand-item__radio {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 9;
}

.brand-item__multi-tag {
  position: absolute;
  top: 8px;
  right: 8px;
  color: #ffffff;
  background-color: rgb(243, 146, 68);
  font-size: 10px;
  line-height: 16px;
  padding: 0 6px;
  border-radius: 20px;
  z-index: 9;
}

.brand-item__multi-tag--grid {
  top: 4px;
  right: 4px;
  font-size: 9px;
  line-height: 14px;
  padding: 0 4px;
}

.brand-item__collect {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 9;
  font-size: 24px;
  color: #999999;
}

.brand-item__collect .is-active {
  color: #ee0a24;
}

.brand-item__collect--grid {
  top: 4px;
  left: 4px;
  font-size: 16px;
}

.brand-item__grid-card {
  padding: 0 6px 6px;
  background: transparent;
}

.brand-item__grid-image {
  position: relative;
  width: 100%;
  padding-bottom: 100%;
  margin-bottom: 4px;
  overflow: hidden;
  background: #fff;
}

.brand-item__grid-image img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 96%;
  height: 96%;
  object-fit: contain;
}

.brand-item__grid-caption {
  color: #666666;
  font-size: 11px;
  line-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 2px;
}

.brand-item__grid-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 6px;
  gap: 6px;
  padding: 0 2px;
}

.brand-item__grid-price {
  flex: 1;
  min-width: 0;
  color: #ee0a24;
  font-size: 12px;
  font-weight: bold;
  line-height: 16px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.brand-item__grid-price span {
  font-size: 10px;
}

.brand-item__grid-price--empty {
  min-height: 16px;
}

.brand-item__grid-order-btn {
  flex-shrink: 0;
  height: 22px;
  line-height: 22px;
  padding: 0 10px;
  font-size: 11px;
}

.brand-item__list-card {
  display: flex;
  align-items: stretch;
  padding: 8px;
  padding-top: 40px;
  background: #ffffff;
  border-radius: 8px;
}

.brand-item__list-image {
  width: 110px;
  height: 110px;
  flex-shrink: 0;
  margin-right: 16px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #fff;
}

.brand-item__list-image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.brand-item__list-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0;
  padding-top: 2px;
  padding-bottom: 2px;
}

.brand-item__list-title {
  color: #333333;
  font-size: 16px;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  font-weight: bold;
  margin-bottom: 8px;
}

.brand-item__list-meta {
  color: #999999;
  font-size: 13px;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  margin-bottom: 4px;
}

.brand-item__list-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}

.brand-item__list-price {
  color: #ee0a24;
  font-size: 20px;
  font-weight: bold;
  text-align: left;
}

.brand-item__list-price span {
  font-size: 14px;
}

.brand-item__order-btn {
  font-size: 13px;
  padding: 0 16px;
  height: 30px;
  line-height: 30px;
}
</style>
<script>
export default {
  data: function () {
    return {
      front_info: {},
      checked: false,
      detail: false,
      cover_img: "",
      in_collect: false,
      radio: "",
      product_show: false,
    };
  },
  props: {
    reg_no: {
      type: String,
      default: "",
    },
    no_check: {
      type: Boolean,
      default: false,
    },
    is_radio: {
      type: Boolean,
      default: false,
    },
    check_status: {
      type: Boolean,
      default: false,
    },
    item_ind: {
      type: Number,
      default: 0,
    },
    layout: {
      type: String,
      default: 'list',
    },
  },
  computed: {
    itemCount() {
      if (!this.detail || !this.detail.fit_projects) {
        return 0;
      }
      return this.projects_count(this.detail.fit_projects);
    },
    gridCaption() {
      if (!this.detail) {
        return '';
      }
      if (this.itemCount > 0) {
        return this.detail.classify + '类 ' + this.itemCount + '小项';
      }
      return this.detail.classify + '类- ' + this.detail.tit;
    },
  },
  watch: {
    default_checked(newval) {},
  },
  methods: {
    formatSameName(same_name_ty2id){

      if( !same_name_ty2id ){
        return ''
      }

      let ty2id_arr = same_name_ty2id.split(',')
      // console.log(ty2id_arr)
      for(let i = 0, j= ty2id_arr.length; i < j; i++){
        ty2id_arr[i] = (ty2id_arr[i] - 208) + '类';
      }
      return ty2id_arr.join('，')
    },

    formatPrice(price) {
      if (!price || price <= 0) {
        return '面议';
      }
      // 格式化为整数，不带小数
      return Math.round(price).toLocaleString();
    },
    showDetail(item) {
      // return;
      //   this.$router.push({ path: '/brand_detail', query: { id: item.id }})

      this.product_show = true;
    },
    goBack() {
      this.product_show = false;
    },
    goOrder() {
      // 跳转到下单页面
      if (!this.detail || !this.detail.id) {
        this.$common.mAlert(this, '商标信息加载中，请稍候');
        return;
      }
      this.$router.push({
        path: '/order',
        query: {
          pro_id: this.detail.id
        }
      });
    },
    changeCheckStatus() {
      this.$emit("status");
    },
    addCollect() {
      if (!this.detail || !this.detail.reg_no) {
        return;
      }

      console.log("添加收藏22");

      // TODO
      let fav_list = localStorage.getItem("fav_list");
      console.log(fav_list);
      try {
        if (fav_list) {
          fav_list = JSON.parse(fav_list);
        } else {
          fav_list = [];
        }
      } catch (e) {
        fav_list = [];
      }

      console.log(fav_list);
      console.log(this.detail.reg_no);
      if (fav_list.indexOf(this.detail.reg_no) !== -1) {
        //TODO 已存在
        let ind = fav_list.indexOf(this.detail.reg_no);
        this.in_collect = false;
        fav_list.splice(ind, 1);
        this.$common.mAlert(this, "已取消收藏");
      } else {
        //TODO 不存在
        console.log("不存在");
        this.in_collect = true;
        fav_list.push(this.detail.reg_no);
        console.log(fav_list);
        this.$common.mAlert(this, "已收藏");
      }

      localStorage.setItem("fav_list", JSON.stringify(fav_list));
    },

    setCheck() {
      if (this.no_check) {
        return;
      }
      this.checked = this.checked ? false : true;
    },
    ty2id_text(ty2id) {
      return (ty2id - 208 > 10 ? "" : "0") + (ty2id - 208) + "类";
    },
    projects_count(projects) {
      console.log("使用项目");
      console.log(projects);
      let projects1 = projects.split(",");
      let projects2 = projects.split("、");

      let project = projects1;
      if (projects1.length < projects2.length) {
        project = projects2;
      }
      return project.length;
    },
  },
  mounted() {
    if (this.reg_no) {
      //用reg_no请求数据
      this.$common
        .cusHttp(
          this,
          "/api/saas_api.php?action=detail&reg_no=" + this.reg_no,
          {},
          "get"
        )
        .then((res) => {
          res = JSON.parse(res.data);

          if (res.status) {
            var fav_list = localStorage.getItem("fav_list");
            try {
              if (fav_list) {
                fav_list = JSON.parse(fav_list);
              } else {
                fav_list = [];
              }
            } catch (e) {
              fav_list = [];
            }

            if (fav_list.indexOf(this.reg_no) !== -1) {
              this.in_collect = true;
            } else {
              this.in_collect = false;
            }

            this.detail = res.data;
          }
        })
        .catch((err) => {});
    }
  },
};
</script>
